import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@glu/theming';
import styles from './InputComponent.styles';

const InputComponent = ({
  id,
  inputClass,
  classes,
  textarea,
  autoFocus,
  warning,
  /* These shouldn't be passed in as a prop to the input. underscore indicates not used */
  inline: _inline,
  theme: _theme,
  dark: _dark,
  inputElementRef,
  ...props
}) => {
  const Component = textarea ? 'textarea' : 'input';
  const inputRef = useRef(null);

  useEffect(() => {
    if (autoFocus) {
      const refToUse = inputElementRef || inputRef;
      refToUse.current.focus();
    }
  }, [autoFocus, inputElementRef]);

  return (
    <Component ref={inputElementRef || inputRef} id={id} {...props} className={`${inputClass} ${classes.input}`} />
  );
};

InputComponent.propTypes = {
  id: PropTypes.string.isRequired,
  /** Name attribute */
  name: PropTypes.string.isRequired,
  /** Classes provided by the theme */
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  /** Custom classes applied to label wrapping component */
  className: PropTypes.string,
  /** Whether to use dark theme */
  dark: PropTypes.bool,
  /** Custom classes applied to input element */
  inputClass: PropTypes.string,
  /** Boolean to indicate whether or not you want the standard inline layout */
  inline: PropTypes.bool,
  /** Theme for styling */
  theme: PropTypes.objectOf(PropTypes.any),
  /** Boolean to indicate whether to render a text area instead */
  textarea: PropTypes.bool,
  /** Boolean to indicate whether the input should receive focus */
  autoFocus: PropTypes.bool,
  /** Use warning styles for error if true */
  warning: PropTypes.bool,
  /**
   * Used to pass an internal ref. I can't use React.forwardRef because of the wrappers
   * currently being used around the input (i.e. withStyles, withInputAPI)
   */
  inputElementRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) })
};

InputComponent.defaultProps = {
  className: '',
  dark: false,
  inputClass: '',
  inline: false,
  textarea: false,
  theme: {},
  autoFocus: false,
  warning: false,
  inputElementRef: null
};

const StyledInputComponent = withStyles(styles)(InputComponent);
export default StyledInputComponent;
export const BaseInputComponent = InputComponent;
